import React from 'react';
import { Button } from 'primereact/button';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../App.css';
import "./Results.css"
import ChatBot from '../ChatBot';
import { format } from "date-fns"
import RandomUtils from '../../utils/RandomUtils'


const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;




function ResultsLuceGas({}) {
  const location = useLocation();
 

  let initMessages =[{
    id: RandomUtils.randomInteger(1,99999),
    tipo: 'risultati_ricerca_luce_gas',
    testo:"Queste sono le migliori offerte che ho trovato per te... Dammi la tua preferenza e poni alla <b>tua IA</b> qualsiasi domanda su esse",
    sender: 'bot',
    time: format(new Date(), "HH:mm"),
    results:location.state?.data.tariffs,
    leadId: location.state?.data.leadId
}]

  


  return (
   <ChatBot initMessages={initMessages}  urlBotImage={IMAGE_URL+ "/logoAIBlue.png"}/>
  )
}



export default ResultsLuceGas;